module.exports = __webpack_public_path__ + "img/mobilepartyterminal3.02003bb8.png";